// Nis genisletme: satan ilham listesinden (best seller) kopya degil OZGUN fikirler — alt nis,
// capraz nis, farkli durum, eksik giderme. Fikirler Trend Radari'nda dogrulanir (Etsy talep/rekabet +
// USPTO); buradan tasarim uretilir (baslik/etiket otomatik), satis radarda izlenir.

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clsx } from "clsx";
import { ChevronDown, ChevronUp, Compass, Loader2, Sparkles, Wand2 } from "lucide-react";
import { authHeaders, getBackendUrl } from "../../lib/http";
import { DEFAULT_NICHE_IDEA_MODEL, NICHE_IDEA_MODELS } from "@erc/shared";

interface Idea {
  id: string; type: "sub" | "cross" | "occasion" | "gap"; reasonTr: string;
  idea?: string; suggestedText?: string; keyword?: string; status?: string; score?: number | null;
  competitionScore?: number | null; totalResults?: number | null; ipLevel?: string | null;
  designStatus?: string | null; designError?: string | null; designs: Array<{ id: string; sku: string | null; url: string }>;
}
interface Expansion { at: string; model?: string; audienceTr: string; whySellsTr: string; ideas: Idea[] }

const TYPE: Record<Idea["type"], [string, string]> = {
  sub: ["Alt niş", "bg-indigo-50 text-indigo-700"],
  cross: ["Çapraz niş", "bg-amber-50 text-amber-800"],
  occasion: ["Farklı durum", "bg-sky-50 text-sky-700"],
  gap: ["Eksik giderme", "bg-emerald-50 text-emerald-700"],
};

async function call<T>(method: string, path: string, body?: unknown): Promise<T> {
  const r = await fetch(`${getBackendUrl()}/api${path}`, { method, headers: { ...authHeaders(), "Content-Type": "application/json" }, ...(body ? { body: JSON.stringify(body) } : {}) });
  const j = await r.json().catch(() => null);
  if (!r.ok) throw new Error(j?.error ?? `İstek başarısız (${r.status})`);
  return j.data as T;
}

const MODEL_KEY = "erc:niche:model";

export function NicheExpansionPanel({ analysisId }: { analysisId: string }) {
  const [open, setOpen] = useState(false);
  // Son secilen model hatirlanir
  const [model, setModel] = useState<string>(() => {
    try { const v = localStorage.getItem(MODEL_KEY); return NICHE_IDEA_MODELS.some((m) => m.id === v) ? v! : DEFAULT_NICHE_IDEA_MODEL; } catch { return DEFAULT_NICHE_IDEA_MODEL; }
  });
  const pickModel = (v: string) => { setModel(v); try { localStorage.setItem(MODEL_KEY, v); } catch { /* yok */ } };
  const qc = useQueryClient();
  const key = ["niche-expand", analysisId];
  const { data } = useQuery({ queryKey: key, queryFn: () => call<Expansion | null>("GET", `/analyses/${analysisId}/niche-expand`) });
  // Dogrulama / tasarim surerken kendiliginden tazelenir
  const busy = !!data?.ideas.some((i) => i.status === "pending" || i.status === "checking" || i.designStatus === "generating");
  useEffect(() => {
    if (!busy) return;
    const t = setInterval(() => void qc.invalidateQueries({ queryKey: key }), 5000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busy]);
  useEffect(() => { if (data) setOpen(true); }, [!!data]);

  const expand = useMutation({
    mutationFn: () => call<Expansion>("POST", `/analyses/${analysisId}/niche-expand`, { model }),
    onSuccess: () => { setOpen(true); void qc.invalidateQueries({ queryKey: key }); },
  });
  const design = useMutation({
    mutationFn: (ideaId: string) => call("POST", `/trend-intelligence/ideas/${ideaId}/design`, {}),
    onSuccess: () => void qc.invalidateQueries({ queryKey: key }),
  });

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-2">
        <button onClick={() => setOpen((o) => !o)} aria-expanded={open} className="flex min-w-0 flex-1 items-center gap-2 text-left">
          <Compass className="h-4 w-4 text-indigo-500" />
          <span className="text-base font-semibold text-gray-900">Niş genişlet</span>
          <span className="truncate text-xs text-gray-500">Kopyalamadan: alt niş, çapraz niş, eksik giderme</span>
          {open ? <ChevronUp className="ml-auto h-4 w-4 shrink-0 text-gray-400" /> : <ChevronDown className="ml-auto h-4 w-4 shrink-0 text-gray-400" />}
        </button>
        <select value={model} onChange={(e) => pickModel(e.target.value)} aria-label="Fikir üretme modeli" disabled={expand.isPending}
          className="shrink-0 rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-xs text-gray-700 focus:outline-none">
          {NICHE_IDEA_MODELS.map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
        </select>
        <button onClick={() => expand.mutate()} disabled={expand.isPending}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-indigo-700 disabled:bg-indigo-300">
          {expand.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />} {data ? "Yeni fikirler üret" : "Fikir üret"}
        </button>
      </div>
      {expand.isPending && <p className="mt-2 text-sm text-gray-600">İlham listesi inceleniyor, fikirler çıkarılıyor (20–40 sn)…</p>}
      {expand.error && <p className="mt-2 rounded-lg bg-red-50 p-3 text-sm text-red-700">{(expand.error as Error).message}</p>}

      {open && data && (
        <div className="mt-3 space-y-3">
          <div className="rounded-lg bg-gray-50 p-3 text-sm text-gray-700">
            <p><span className="font-medium text-gray-900">Kim alıyor:</span> {data.audienceTr}</p>
            <p className="mt-1"><span className="font-medium text-gray-900">Neden satıyor:</span> {data.whySellsTr}</p>
            {data.model && <p className="mt-1 text-xs text-gray-500">Model: {NICHE_IDEA_MODELS.find((m) => m.id === data.model)?.label.replace(/ \(.*/, "") ?? data.model}</p>}
          </div>
          <ul className="space-y-2">
            {data.ideas.map((i) => {
              const checking = i.status === "pending" || i.status === "checking";
              const ipHigh = i.ipLevel === "high";
              return (
                <li key={i.id} className="rounded-lg border border-gray-200 p-3">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={clsx("rounded-full px-2 py-0.5 text-xs font-medium", TYPE[i.type][1])}>{TYPE[i.type][0]}</span>
                    <span className="text-sm font-semibold text-gray-900">{i.suggestedText}</span>
                    <span className="text-xs text-gray-500">"{i.keyword}"</span>
                    <span className="ml-auto flex items-center gap-2 text-xs">
                      {checking ? <span className="flex items-center gap-1 text-gray-500"><Loader2 className="h-3 w-3 animate-spin" /> Etsy'de doğrulanıyor</span> : (
                        <>
                          {i.score != null && <span className="rounded-full bg-gray-100 px-2 py-0.5 font-medium text-gray-700" title="Fırsat puanı (talep / rekabet / aciliyet / marka riski)">Puan {i.score}</span>}
                          {i.totalResults != null && <span className="text-gray-500">{i.totalResults.toLocaleString("tr-TR")} sonuç</span>}
                          {i.ipLevel && <span className={clsx("rounded-full px-2 py-0.5 font-medium", ipHigh ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-800")}>{ipHigh ? "Tescilli marka" : "Marka dikkat"}</span>}
                        </>
                      )}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-gray-600">{i.reasonTr}</p>
                  {i.idea && <p className="mt-1 text-xs text-gray-500">{i.idea}</p>}
                  <div className="mt-2 flex flex-wrap items-center gap-2">
                    {i.designs.map((d) => (
                      <Link key={d.id} to={`/designs?search=${encodeURIComponent(d.sku || d.id)}`} title={d.sku ?? ""}
                        className="bg-alpha-check h-14 w-14 overflow-hidden rounded-lg border border-gray-200">
                        <img src={d.url} alt="" loading="lazy" className="h-full w-full object-contain" />
                      </Link>
                    ))}
                    {i.designStatus === "generating" ? (
                      <span className="flex items-center gap-1 text-xs text-gray-600"><Loader2 className="h-3 w-3 animate-spin" /> Tasarım üretiliyor…</span>
                    ) : (
                      <button onClick={() => design.mutate(i.id)} disabled={checking || ipHigh || design.isPending}
                        title={ipHigh ? "Tescilli marka çıktı: üretilmez" : "Radar ayarındaki modelle tasarım üret (başlık/etiket otomatik)"}
                        className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50">
                        <Wand2 className="h-3.5 w-3.5" /> {i.designs.length ? "Bir tasarım daha" : "Tasarım üret"}
                      </button>
                    )}
                    {i.designError && <span className="text-xs text-red-600">{i.designError}</span>}
                  </div>
                </li>
              );
            })}
          </ul>
          <p className="text-xs text-gray-500">
            Fikirler <Link to="/trend-intelligence" className="text-indigo-600 hover:underline">Trend Radarı</Link>'nda da görünür; taslak, görüntülenme ve satış orada izlenir. Satan nişten daha çok liste üret.
          </p>
          {design.error && <p className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{(design.error as Error).message}</p>}
        </div>
      )}
    </section>
  );
}
